// extracted by mini-css-extract-plugin
var _1 = "SearchPlatformTab-module__activeTab--LRzCz";
var _2 = "SearchPlatformTab-module__animateUploadProgressBarWidth--XyS49";
var _3 = "SearchPlatformTab-module__animatedBackground--ZV2xH";
var _4 = "SearchPlatformTab-module__integrationSettings--kTWsF";
var _5 = "SearchPlatformTab-module__meta--V6h2I";
var _6 = "SearchPlatformTab-module__searchPlatform--fiWF_";
var _7 = "SearchPlatformTab-module__searchPlatformName--nRh1B";
var _8 = "SearchPlatformTab-module__settingsSectionTitle--PdIji";
var _9 = "SearchPlatformTab-module__tab--iF4Fo";
var _a = "SearchPlatformTab-module__verticalLine--yvRwB";
export { _1 as "activeTab", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "integrationSettings", _5 as "meta", _6 as "searchPlatform", _7 as "searchPlatformName", _8 as "settingsSectionTitle", _9 as "tab", _a as "verticalLine" }
